'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotMesh3dIcon = function PlotMesh3dIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M16 0L1.312 8v16L16 32l14.688-8V8zM4 11.313l4 2v4.125l-4-2.25zm19.063-.25l-4.688-2.375 4.188-2 4.5 2.5zm-2.25 1.187L16 14.688l-4.813-2.438L16 9.875zM8.938 11.063l-4-2 4.5-2.375 4.188 2zm1.75 3.625l4 2v4.5l-4-2.25zm4 9.437v4l-4-2.125v-4.125zm2.625 0l4-2.25V26l-4 2.125zm0-2.937v-4.5l4-2v4.25zM24 13.313l4-2v3.875l-4 2.25zm-3.75-8L16 7.438l-4.25-2.125L16 3.063zM4 18.25l4 2.313v4.125l-4-2.125zm20 6.438v-4.125l4-2.313v4.125z' })
    );
};

exports.default = PlotMesh3dIcon;